import { useTypedLoaderData, typedjson } from 'remix-typedjson'
import { GetOrganizationUseCase } from '~/domain/organization/usecases/GetOrganizationUseCase'
import { MarkdownContents } from '~/application/components/MarkdownContents/MarkdownContents'

export async function loader({ params }: { params: { id: string } }) {
  const { id } = params
  const getOrganizationUseCase = GetOrganizationUseCase.create()
  const result = await getOrganizationUseCase.execute(Number(id))

  if (result.isErr()) {
    throw new Error('Organization not found')
  }

  return typedjson({
    organization: result.value,
  })
}

export default function Index() {
  const { organization } = useTypedLoaderData<typeof loader>()

  return (
    <div>
      <MarkdownContents markdown={organization.description} />
    </div>
  )
}
